var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_2061_147)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2061_147",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2061_147",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2061_147",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAFGUlEQVR4nO1dPWxcRRBeIogBOdzO2RSBkDQGpDQgnXefQUYB8SvCrwQ1FSfMm3nGhv5aJED8KYWRoKDmJ6IDqiiCEvKHhAQOQQaaKMbpoLAfmrvQIBzd3du92Xc3nzTSyXq+253v7ezs7OysMQqFQqFQKBQKhUKREKbvppubnh6xjgg8HbOevgZHZ8DjOjjaBI9/d6X3mf92pvsMP+uI+H/5O6T7URvsb7VvtJ6eBkfv9BRNO+CprCg74PA0f6edpycPLKzcIN3PxNDZA1mxaB2uWYeXAyj8qtL9DYcfN+fxIWPMNWZScejIC9eDo6Wu6Yis9N2FzVb+kpmjKTNJZgYcvmo9/iGn+P+OCvodHK2OvXliGwwOf5FWOOxunjaanp4z4wZ7z8uHwOMX0gqGfsXhcWgVB8044IpXsymuVD/waLjc9Pi8qS3maAo8vRvIlSwFiVgzhzt7TZ1w08JK03r6Vlp5EEocnmwsLoGpA2Zbr+zvLnykleaDj4QfYH7pNpMyZuaX7wSPv0orC6KNBLow6/I7TIpoLqzcyg0UV5KPPhI2kvOQGnct23E0O7AbCZ7O8TxnksAcTVmP30grBUYtDk8m4R2Bo/fFleHFSHhbPrRQcz8fqslOwxXPSoYX/kxACaXsKKBNEfe0VrEdH1vws9HHd8Q7TUmJdfkTo4znJxtSBjHB9ZHsJ4Cn1+Q7S0mKzfLl+D4/7x4l0FlIdJUcdXuzt4cr31FIWbKiHUn9nT0xNtCNMIIT4OinKNkWDU8PxHhjjDBi9Ml6vC98Qx19pARQnwTQB0GVz+4VeNpSAqjfUbAV1CWNufAywojVL/B4NGQjeXNdCfCDzAP0ZjgCeomySoAfaAR8F0T5nN4dM+RsxtcEbU+3VmerN9Dlj8ZrJI0xAVReycCuBuuwUAJoKAKspzzEG3JMCaBhzdB71UdA78iPmiA/xAhw+GUAAvCsEkDDvYAOT1cmIHaylRFGzL6Bo/PVG+jwkhJAw84BFwO8IXwUVEcADEfAX0pA7QlQE1TKmiCdhEvRSVjdUJJ1Q3UhRrILMQ1FkHAoQoNxpWwwTsPRpWg4WjdkaFjzs73P5TOVCeiNgnjnv4wwkt+S7DaSCygpAeWAHtAbwQiwWf6UEkCDjYCseDwYAZqYRbKJWQzr8EOdA6hf87NmQqOR5fcrAdSv+VkMTgCnXGt6OsmlpzP0gAb1QQC+aOIeUcLf4vnOVGuJfkSJwdUFpTsKiQrHzUxsdF1SR+elOwvJCf7MtVDNKACOHpPvMCUmAc8D9EcCHpfvNCUh1tEnI1V+l4BWcbCO5SghtDi81PR0wEiA6yNMfLkaj88YScSMlELiEvQY0tA43NnL5buklQEjFzxhWu3rTAqAVrsBjk5NzpuPZ5Mr5Dpzb37LJJSxsVy2MtUCrlzUdKxrhzq6sC8rbjfply4eP3NkPZ0TczcHBdvH8ZqY8QQXpzW1wpHOtdbj6zVfJ+xwlYAkCrRW2tCPnOIOcWRrbK4zYa8BHH2egFLLPuXT2tj7QdBwxYPW448JKLj8f8H1oOkkKYL3E7i6YEo7a9bhBm+mjCyen8wdM1nR5k1sMeXzb3ORvTpPsiHQyIpWryYRXhyB4rf0KsOrXW/o8aj1+BZ4/J4zjAPY9W1OlOXIJdv3yTIzFTHdWp1tZvnDfNCB7ymwjr7qrbL5Dkh2bf+9zrb7ma+zPcXHgrrPeso5Pz9YirhCoVAoFAqFQqFQmDD4BxA55QgvkOwkAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopButton);
export default __webpack_public_path__ + "static/media/StopButton.fb3d923dda06975146e5e0c25672884e.svg";
export { ForwardRef as ReactComponent };